import { useCallback, useRef } from "react";

export const useMessageTimeFormatter = () => {
  const cacheRef = useRef<Map<string, string>>(new Map());

  const formatMessageTime = useCallback((value: any) => {
    if (value == null) return "";

    const key = String(value);
    const cached = cacheRef.current.get(key);
    if (cached != null) return cached;

    const d = new Date(value);
    if (Number.isNaN(d.getTime())) {
      cacheRef.current.set(key, key);
      return key;
    }

    const now = new Date();
    const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const startOfYesterday = new Date(startOfToday);
    startOfYesterday.setDate(startOfYesterday.getDate() - 1);

    const hhmm = d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
    const result =
      d >= startOfToday
        ? hhmm
        : d >= startOfYesterday
          ? "Yesterday"
          : `${d.toLocaleDateString()} ${hhmm}`;

    cacheRef.current.set(key, result);
    if (cacheRef.current.size > 500) {
      const firstKey = cacheRef.current.keys().next().value;
      if (firstKey) cacheRef.current.delete(firstKey);
    }

    return result;
  }, []);

  return { formatMessageTime };
};
